<template>
<layout-base :title="!resendActive ? $t('REGISTRATION_CODE_STEP.TITLE') : $t('REGISTRATION_CODE_STEP.RESEND.TITLE')">
  <template slot="content">
  <div class="bk-reg__opener mdc-typography mdc-typography--body2">
    {{!resendActive ? $t('REGISTRATION_CODE_STEP.ENTER_SECURITY_CODE'): $t('REGISTRATION_CODE_STEP.RESEND.DESCRIPTION')}}
  </div>
  <div v-if="!resendActive">
    <bk-input icon="lock"
              class="input"
              :label="$t('REGISTRATION_CODE_STEP.SECURITY_CODE')"
              :value="registrationCode"
              :valid="isRegistrationCodeValid"
              :pristine="registrationCodePristine"
              @input="changeRegistrationCode"
              id="registrationCode"
              :helper-text="$t(helperTextState)"
              :loading="registrationCodeLoading"
    />

    <p>{{ $t('REGISTRATION_CODE_STEP.GOT_NO_EMAIL_LABEL')}}</p>
    <div class="back-button aligned" @click="resendActive = true">{{$t('REGISTRATION_CODE_STEP.GET_NO_EMAIL')}}</div>
  </div>


  <div v-else>
    <bk-email
              :email="email"
              @change="emailChange"
              :valid="emailValid && emailAddressIsValid"
              :state="emailState"
              id="resendEmailInput"
              :loading="emailLoading"
    />
    <div class="back-button" @click="resendActive = false">
      {{$t('GLOBAL.BACK')}}
    </div>
  </div>

  </template>

  <template slot="buttons">
  <bk-button v-if="!resendActive" :disabled="!registrationCodeLengthIsValid" @click="validateRegistrationCode">
    {{$t('REGISTRATION_CODE_STEP.CONFIRM')}}
  </bk-button>
  <bk-button v-else @click="resendRegistrationCode">{{$t('REGISTRATION_CODE_STEP.RESEND.BUTTON')}}</bk-button>
  </template>
</layout-base>
</template>
<script>
import LayoutBase from './LayoutBase'
import BkEmail from '../components/Email'
import emailCheckMixin, { EmailState } from '../../../mixins/emailCheck'
import BkInput from '../../../common/BkInput'
import BkFlatButton from '../../../common/BkFlatButton'
import BkButton from '../../../common/BkButton'
import BkBackButton from '../../../common/BkBackButton'

const State = Object.freeze({
  default: 'REGISTRATION_CODE_STEP.DEFAULT',
  invalid: 'REGISTRATION_CODE_STEP.INVALID'
})

export default {
  components: {
    BkEmail,
    LayoutBase,
    BkInput,
    BkFlatButton,
    BkButton,
    BkBackButton,
  },
  data () {
    return {
      /**
       * When true the "resend email" view is active
       */
      resendActive: false,
      /**
       * The registration code
       */
      registrationCode: '',
      registrationCodePristine: true,
      registrationCodeLoading: false,
      email: '',
      emailLoading: false,
      emailState: EmailState.empty_resend,
      helperTextState: State.default,
    }
  },
  mixins: [emailCheckMixin],
  computed: {
    valid () {
      return this.state === State.default
    },
    registrationCodeLengthIsValid () {
      return this.registrationCode.toString().length === 6
    },
    isRegistrationCodeValid(){
      return this.registrationCodeLengthIsValid && this.helperTextState !== State.invalid
    },
    emailAddressIsValid(){
      return this.emailState !== EmailState.invalid
    },
  },
  methods: {
    emailChange (email) {
      this.emailLoading = true
      this.validateEmail(email).then(() => this.emailLoading = false)
      this.email = email
    },
    resendRegistrationCode () {
      this.requestEmailChange(this.email)
        .then(data => {
          if (!data.state) this.emailState = EmailState.invalid
          else this.resendActive = !data.state

          this.fireTrackEvent('BestätigungscodeEingeben', 'EMailErneutGesendet')
        })

    },
    validateRegistrationCode () {
      this.registrationCodeLoading = true
      this.requestValidateRegistrationCode(this.registrationCode)
        .then(response => {
          if (response.state) {
            this.$router.push('finish')
            this.fireTrackEvent('DoubleOptin', 'Abgeschlossen')
          } else {
            this.helperTextState = State.invalid
            this.fireTrackEvent('DoubleOptin', 'wrong')
          }
        })
        .catch(() => {
          this.helperTextState = State.invalid
          this.fireTrackEvent('DoubleOptin', 'wrong')
        })
        .finally(() => {
          this.registrationCodeLoading = false
        })
    },
    changeRegistrationCode (code) {
      this.registrationCode = code
      this.registrationCodePristine = false
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "../../../scss/colors";

  .bk-reg__opener {
    margin-bottom: 32px;
  }

  .input {
    margin-bottom: 16px;
  }

  .back-button {
    color: $primary;
    text-align: center;
    cursor: pointer;
  }

  .back-button.aligned{
    text-align: left;
  }
</style>
